import { render, staticRenderFns } from "./ButtonContainerCompact.vue?vue&type=template&id=34f422f4&scoped=true&"
import script from "./ButtonContainerCompact.vue?vue&type=script&lang=js&"
export * from "./ButtonContainerCompact.vue?vue&type=script&lang=js&"
import style0 from "./ButtonContainerCompact.vue?vue&type=style&index=0&id=34f422f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f422f4",
  null
  
)

export default component.exports